var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.page ? _c('div', [_c('vue-title', {
    attrs: {
      "title": "Seasons - Whoosh! Your Indoor Cycling Solution"
    }
  }), _c('section', {
    staticClass: "seasons-main seasons-page-wrap clearfix"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-12"
  }, [_c('SeasonList', {
    attrs: {
      "seasons": _vm.seasons,
      "loading": _vm.loading,
      "pagination": _vm.pagination
    },
    on: {
      "page-changed": _vm.handlePageChange
    }
  })], 1)])])])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }